import React from "react";
import { formatMoney } from "accounting-js";
import { connect } from "react-redux";
import IconSuccess from "../IconSuccess";
import IconWarning from "../IconWarning";
import { Badge } from "react-bootstrap";
import style from "./SaasBundleOptions.module.css";
import BackorderFlag from "../BackorderFlag";

function SaasBundleOptions({ parentQty, options, itemValidationMap, subscriptionTerm, itemKey, backendValidationMessages}) {
  return options.map(o => (
    <React.Fragment key={o.optionId}>
      <tr>
        <td>
          <h5 className={style.optionName}>{o.optionName}</h5>
        </td>
        <td colSpan="6" />
      </tr>

      {o.selections.map(s => {
        const isAvailable = !itemValidationMap.some(
          item => Number(item.productId) === Number(s.productId)
        );
        const backendValidationErrors = backendValidationMessages.filter(err => err.id === itemKey && err.selectionIds.includes(Number(s.selectionId)));

        return (
          <React.Fragment key={`selections-${s.selectionId}`}>
          <tr>
            <td>
              {s.name}{" "}
              {s.excludeFromMarginSplit && (
                <Badge variant="danger">Excluded from margin splitting</Badge>
              )}
            </td>
            <td>
              {!s.isSass || (<BackorderFlag quantity={s.inventory_qty} />) }
            </td>
            <td className="text-center">
              {s.isSaas && <IconSuccess />}
              {!s.isSaas && (!isAvailable || (s.inventory_qty !== null && s.inventory_qty <= 0) ? <IconWarning /> : <IconSuccess />)}
            </td>
            <td className="text-muted">{formatMoney(Number(s.price))}</td>
            <td className="text-muted">{formatMoney(Number(s.targetPrice))}</td>
            <td>{s.isSaas ? subscriptionTerm + " Months" : ""}</td>
            <td className="text-muted">
              {parentQty > 1
                ? `${s.qty} x ${parentQty} = ${s.qty * parentQty}`
                : s.qty * parentQty}
            </td>
            <td className="text-muted">
              {s.isSaas 
                ? formatMoney(Number(s.targetPrice * s.qty * parentQty * subscriptionTerm))
                : formatMoney(Number(s.targetPrice * s.qty * parentQty))
              }
            </td>
            <td>
              {s.financeType}
            </td>
            <td />
          </tr>
          {backendValidationErrors.map((err, index) => 
              <tr key={`${err.id}-${s.selectionId}-${index}`}>
                <td className="alert-danger" colSpan="10">{err.errorMessage}</td>
              </tr>
            )
          }
          </React.Fragment>
        );
      })}
    </React.Fragment>
  ));
}

export default connect(state => ({
  itemValidationMap: state.quote.itemValidationMap,
  backendValidationMessages: state.quote.backendValidationMessages
}))(SaasBundleOptions);
